<template>
    <NavbarMain/>

    <PresentationSection :photo="first_section_image_en" :title="first_section_title_en" :content="first_section_content_en"/>

    <section class="page-section section-faq" style="height: auto;">
        <div class="container" style="height: auto;">
            <ul class="faq-list">
                <li v-for="(item, index) in questions" :key="item.id || index" class="faq-item">
                    <h5 class="faq-question" @click="toggle(index)">
                        <span class="faq-toggle-icon">{{ openIndex === index ? '−' : '+' }}</span>
                        <span v-safe-html="item.question" class="faq-question-text" />
                    </h5>
                    <div v-show="openIndex === index" class="faq-answer">
                        <div v-safe-html="item.answer" />
                    </div>
                </li>
            </ul>
            <p v-if="questions.length === 0" class="faq-empty">No questions available.</p>
        </div>
    </section>

    <WidePhotoComponent :photo="second_section_image_en" :content="second_section_content_en" />

    <FooterPage/>
</template>

<script>
import axios from 'axios';
import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';
import PresentationSection from '@/components/PresentationSection.vue';
import WidePhotoComponent from '@/components/WidePhotoComponent.vue';

export default {
    components: {
        NavbarMain,
        FooterPage,
        WidePhotoComponent,
        PresentationSection
    },
    data() {
        return {
            faqData: { items_en: [{}], questions_en: [] },
            openIndex: null,

            first_section_title_en: '',
            first_section_content_en: '',
            first_section_image_en: '',
            second_section_image_en: '',
            second_section_content_en: '',
        }
    },
    computed: {
        questions() {
            const list = this.faqData.questions_en;
            if (!Array.isArray(list)) return [];
            return list.filter(q => q && q.active !== false);
        },
    },
    methods: {
        toggle(index) {
            this.openIndex = this.openIndex === index ? null : index;
        },
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/faq-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.faqData = response.data || { items_en: [], questions_en: [] };

                if (this.faqData.items_en[0]?.active === true) {
                    this.first_section_title_en = this.faqData.items_en[0].first_section_title;
                    this.first_section_content_en = this.faqData.items_en[0].first_section_content;
                    this.first_section_image_en = this.faqData.items_en[0].first_section_image;
                    this.second_section_image_en = this.faqData.items_en[0].second_section_image;
                    this.second_section_content_en = this.faqData.items_en[0].second_section_content;
                }
            })
            .catch(error => {
                console.error('Error fetching FAQ data:', error);
            });
    }
}
</script>

<style scoped>
.section-faq {
    padding: 2rem 0;
}

.faq-list {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    max-width: 900px;
    text-align: left;
}

.faq-item {
    border-bottom: 1px solid #E1E5E8;
}

.faq-question {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    cursor: pointer;
    padding: 1rem 0;
    margin: 0;
    font-size: 18px;
    color: #0058A3;
}

.faq-toggle-icon {
    flex-shrink: 0;
    width: 1.2rem;
    font-weight: 700;
}

.faq-question-text {
    display: inline-block;
}

.faq-answer {
    padding: 0 0 1.25rem 1.95rem;
    color: #2c3e50;
    line-height: 1.6;
}

.faq-empty {
    color: #6E8496;
    font-style: italic;
}
</style>
